import { render, staticRenderFns } from "./GBoothDesignForm.vue?vue&type=template&id=c49f73dc&scoped=true&"
import script from "./GBoothDesignForm.vue?vue&type=script&lang=ts&"
export * from "./GBoothDesignForm.vue?vue&type=script&lang=ts&"
import style0 from "./GBoothDesignForm.vue?vue&type=style&index=0&id=c49f73dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c49f73dc",
  null
  
)

export default component.exports